import { FormTextarea, Loader } from "@/components";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useLatestNews from "./useLatestNews";
import { NEWS } from "./consts";
import { useState } from "react";

const tabs = ["Ostwal", "MBAPL", "KPL"];

const LatestNews = () => {
  const [activeTab, setActiveTab] = useState("Ostwal");
  const { form, onSubmit, requiredFields, isLoadingLatestNews, isAddPending } =
    useLatestNews(activeTab);
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {isLoadingLatestNews ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            {/* Tabs */}
            <div className="flex items-center gap-4 mb-4 border-b pb-2">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 rounded-t-md font-medium transition-colors duration-150 cursor-pointer ${
                    activeTab === tab
                      ? "text-[#E2544B] border-b-2 border-[#E2544B]"
                      : "text-gray-500 hover:text-[#E2544B]"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Form Section */}
            <div className="bg-white rounded-sm px-[30px] py-[25px]">
              <div className="grid grid-cols-1 gap-[30px]">
                <FormTextarea
                  name={NEWS}
                  label="News"
                  placeholder="Enter Latest News"
                  error={errors[NEWS]?.message}
                  isRequired={requiredFields.includes(NEWS)}
                />
              </div>
              <div className="flex flex-row justify-end gap-3 py-3">
                <Button type="submit" disabled={isAddPending}>
                  {isAddPending && <Loader variant="secondary" />}
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default LatestNews;
